<div class="sortable-item" (click)="onClick()">
  {{ name}}
  <i *ngIf="direction === ''" class="fas fa-sort"></i>
  <span class="active" *ngIf="sort === current.sort">
    <i *ngIf="direction === 'ASC'" class="fas fa-sort-up"></i>
    <i *ngIf="direction === 'DESC'" class="fas fa-sort-down"></i>
  </span>
</div>
